import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

import { delayMessage } from "../../utils/delayMessage";
import { serverMessage } from "../../utils/serverMessage";
import { getToken } from "../../utils/tokenStorage";
import { url } from "../../utils/config";

interface DeleteProps {
  isDeleting: boolean;
  pendingRequestTimer: any;
}

const initialState: DeleteProps = {
  isDeleting: false,
  pendingRequestTimer: null,
};

export const deleteJobAction = createAsyncThunk(
  "deleteJob",
  async (id: string, thunkAPI) => {
    try {
      const token = getToken();
      const { data } = await axios.delete(`${url.baseUrl}/job/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error: any) {
      console.log(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const deleteSlice = createSlice({
  name: "deleteJob",
  initialState,
  reducers: {
    //
  },

  extraReducers: (builder) => {
    builder
      .addCase(deleteJobAction.pending, (state) => {
        state.isDeleting = true;
        // Start a timer to show toast message if request is still pending after 10 seconds
        state.pendingRequestTimer = setTimeout(delayMessage, 10000);
      })
      .addCase(deleteJobAction.fulfilled, (state, { payload }: any) => {
        state.isDeleting = false;
        toast.success(payload.data.message); // Job deletion success message
        // Clear timeout
        state.pendingRequestTimer && clearTimeout(state.pendingRequestTimer);
      })
      .addCase(deleteJobAction.rejected, (state, { payload }: any) => {
        state.isDeleting = false;
        serverMessage(payload);
        // Clear timeout
        state.pendingRequestTimer && clearTimeout(state.pendingRequestTimer);
      });
  },
});

export default deleteSlice.reducer;
